

import './collector';
import './shop';

import './signup.component';
import './signup.controller';
import './_signup.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('signup', {
    url: '/signup?as',
    views: {
      '@': {
        component: 'inkSignup'
      }
    },
    resolve: {
      $title: (() => 'Signup for Ink Finder'),
      as: function($stateParams, _) {
        if (_.isUndefined($stateParams.as)) {
          return 'collector';
        }
        return $stateParams.as;
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/signup/index.js